/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// The result of the response after uploading the file
export interface IUploadFileResponse {
  errorCount: number;
  errorList: IErrorInfo[];
  rowCount: number;
  successCount: number;
}

export interface IErrorInfo {
  rowNumber: number;
  name: string;
  email: string;
  team: string;
  message: string;
}

export type IKidType = 'beforeUpload' | 'processing' | 'fileSelected' | 'fail' | 'success';

export enum KidType {
  BeforeUpload = 'beforeUpload',
  Processing = 'processing',
  FileSelected = 'fileSelected',
  Fail = 'fail',
  Success = 'success',
}
